import { render, staticRenderFns } from "./CategoryIconPicker.vue?vue&type=template&id=43e113a0&scoped=true"
import script from "./CategoryIconPicker.vue?vue&type=script&lang=js"
export * from "./CategoryIconPicker.vue?vue&type=script&lang=js"
import style0 from "./CategoryIconPicker.vue?vue&type=style&index=0&id=43e113a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e113a0",
  null
  
)

export default component.exports